import { type ComponentConfig, registerOverlayPortal, type SlotComponent } from '@puckeditor/core';
import { useEffect, useRef } from 'react';
import TabBlockAlpha from '~/editor/templates/alpha/TabBlockAlpha';
import { IsTabProvider } from '~/hooks/useIsTab';

export interface TabBlockProps {
	tabs: number;
	slots: SlotComponent[];
}

export const PUCK_BLOCK_TAB: ComponentConfig<TabBlockProps> = {
	label: 'Tabs',
	fields: {
		tabs: {
			type: 'number',
		},
		slots: {
			type: 'array',
			arrayFields: {
				content: { type: 'slot', disallow: ['Tab'] },
			},
			visible: false,
		},
	},
	defaultProps: {
		tabs: 2,
		slots: [],
	},
	resolveData: (data, params) => {
		// Skip if numZones hasn’t changed or is invalid
		if (!params.changed.tabs || data.props.tabs < 0) {
			return data;
		}

		const newData = { ...data, props: { ...data.props } };
		newData.props.slots = [];

		for (let i = 0; i < newData.props.tabs; i++) {
			newData.props.slots.push(data.props.slots[i] ?? { content: [] });
		}

		return newData;
	},
	render(props) {
		return <TabBlock {...props} />;
	},
};

export default function TabBlock(props: TabBlockProps) {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => registerOverlayPortal(ref.current), [ref.current]);

	const tabs = props.slots.map((Slot, index) => ({
		name: `Tab ${index + 1}`,
		content: <Slot />,
	}));

	return (
		<IsTabProvider>
			<TabBlockAlpha ref={ref} tabs={tabs} />
		</IsTabProvider>
	);
}
